import { render, staticRenderFns } from "./requestQueue.vue?vue&type=template&id=965ca57a"
import script from "./requestQueue.vue?vue&type=script&lang=js"
export * from "./requestQueue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports